import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { IPDashboard } from '../../../features/ip'
import { IPDetailWrapper as IPDetail } from '../../../features/ip-detail'

export const IPRouter = () => {
  return (
    <Routes>
      <Route exact path="/" element={<IPDashboard />} />
      <Route exact path="/:ipId" element={<IPDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
